import { handleAPI, API_VERSION_ONE } from '../../../itrust_common/utils/apiUtils';

export function connectDevicesLoad(filters = {}) {
  const url = `/${API_VERSION_ONE}/integrated_devices`;
  const method = 'GET';
  return {
    type: `CONNECT_DEVICES_LOAD`,
    payload: handleAPI(url,filters, method)
  };
}

export function connectDeviceCreate(data, filters) {
  const url = `/${API_VERSION_ONE}/integrated_devices`;
  const method = 'POST';
  return {
    type: `CONNECT_DEVICE_CREATE`,
    payload: handleAPI(url, filters, method, data)
  };
}

export function connectDeviceUpdate(data, filters) {
  const url = `/${API_VERSION_ONE}/integrated_devices/${data.integrated_device.id || data.id}`;
  const method = 'PUT';
  return {
    type: `CONNECT_DEVICE_UPDATE`,
    payload: handleAPI(url, filters, method, data)
  };
}

export function connectDeviceDelete(id, filters) {
  const url = `/${API_VERSION_ONE}/integrated_devices/${id}`;
  const method = 'DELETE';
  return {
    type: `CONNECT_DEVICE_DELETE`,
    payload: handleAPI(url, filters, method)
  };
}

export function connectDeviceEdit(data) {
  return {
    type: `CONNECT_DEVICE_EDIT`,
    data,
  };
}

export function connectDeviceEditCancel() {
  return {
    type: `CONNECT_DEVICE_EDIT_CANCEL`
  };
}
